export const iconStylesMapping = {
    "cell-phone": {
        height: "auto",
        width: 14,
        opacity: 0.5,
    },
    mail: {
        height: "auto",
        width: 24,
    },
    dni: {
        height: "auto",
        width: 24,
        opacity: 0.4,
    },
    calendar: {
        opacity: 0.4,
    },
    lock: {
        paddingRight: 10,
    },
    person: {
        width: 14,
    },
};
